var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-faq"},[_c('main',{staticClass:"main"},[_c('breadcrumbs'),_c('h1',[_vm._v("Foire aux questions")]),(_vm.questions.length)?_c('faq-accordion',{attrs:{"items":_vm.questions}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }